// TODO getEventTypeCountForEntity is not used anywhere, consider removing
export function getEventTypeCountForEntity(eventType, entityId, events) {
  return events.filter(
    (event) => event.class === "sport" && event.entityId === entityId && eventType === event.eventType,
  ).length;
}

export function getEventTypeEventsForEntity(eventType, entityId, events) {
  return events.filter(
    (event) => event.class === "sport" && event.entityId === entityId && eventType === event.eventType,
  );
}
